import type {CheckoutLineFragment} from 'src/api/saleor/generated'
import {useProductQuery} from 'src/api/saleor/generated'

export const useProduct = ({
  line,
}: {
  line: CheckoutLineFragment
}): ReturnType<typeof useProductQuery> =>
  useProductQuery({
    variables: {slug: line.variant.product.slug},
    skip: !line.variant.product.slug,
  })
